export const LENS_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '18.75rem',
  panelClass: 'people-lens-dialog',
  // disableClose: true,
};
